import { createSelector } from 'reselect';
import get from 'lodash/get';

import { TRANSFER_STATES } from '../constant/transfer-states';

import { allowedSizeSelector } from '@app/selector/transfers';

const transferSelector = (state) => state.transfer;

export const transferUploadInProgress = createSelector(
  transferSelector,
  (transfer) => {
    return [TRANSFER_STATES.STARTED, TRANSFER_STATES.PAUSED].includes(
      transfer.state
    );
  }
);

// Not using reselect because the transfer is currently mutated so much that reselect doesn't recompute
// Do not use this in mapStateToProps because it also will not recompute

export const getCurrentSize = (state) => {
  return get(state, 'transfer.items', []).reduce((currentSize, { size }) => {
    const fileSize = Number(size);
    if (!isNaN(fileSize)) {
      return currentSize + fileSize;
    }
    return currentSize;
  }, 0);
};

export const getRemainingSize = createSelector(
  allowedSizeSelector,
  getCurrentSize,
  (allowedSize, currentSize) => {
    return allowedSize - currentSize;
  }
);

export const getIsForwardedTransfer = createSelector(
  [transferSelector],
  (transfer) => {
    return !!transfer.parent_id;
  }
);
